export default __webpack_public_path__ + "static/media/MediraWolfdaughter_tmb.6060fb6b.jpg";